module.exports = __webpack_public_path__ + "img/y_sure.ec52359b.png";